export const FORMAT_10 = {
  name: 'ddd, D MMM YYYY, HH:mm',
  value: 'ddd, D MMM YYYY, HH:mm',
};

const Basic = [
  { name: 'DD.MM.YYYY', value: 'DD.MM.YYYY' },
  { name: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
  { name: 'DD-MMM-YY', value: 'DD-MMM-YY' },
  { name: 'DD-MMM-YYYY', value: 'DD-MMM-YYYY' },
  { name: 'MM.DD.YYYY', value: 'MM.DD.YYYY' },
  { name: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
  { name: 'MM/DD/YY', value: 'MM/DD/YY' },
  { name: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
  { name: 'YY/MM/DD', value: 'YY/MM/DD' },
  FORMAT_10,
  { name: 'MM-DD-YYYY', value: 'MM-DD-YYYY' },
  { name: 'YYYY.MM.DD', value: 'YYYY.MM.DD' },
  { name: 'YYYY.DD.MM', value: 'YYYY.DD.MM' },
  { name: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
  { name: 'YYYY-MM-DD', value: 'YYYY-MM-DD' },
];

const BasicByValue = Basic.reduce((hash, format) => {
  hash[format.value] = format;
  return hash;
}, {});

export default { Basic, BasicByValue };
